import React, { useState } from "react";
import styles from "./Settings.module.scss";
import SettingsProfile from "@features/settings/settingsProfile/SettingsProfile";
import ChangePassword from "@features/settings/changePassword/ChangePassword";
import { SETTINGS_TABS } from "@constants/common";
import LayoutHeader from "@features/common/header/layoutHeader/LayoutHeader";
import { useAppSelector } from "@redux/hooks";
import { selectDashboardData } from "@redux/slices/CommonSlice";
type TabType = "profile" | "password";

const Settings: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>("profile");
  const dashboardData = useAppSelector(selectDashboardData);

  const getTabClass = (tabName: TabType) => {
    const baseClass = styles["button-wrapper__button"];
    const activeClass = styles["button-wrapper__button--active"];

    return `${baseClass} ${activeTab === tabName ? activeClass : ""}`;
  };
  return (
    <div className={styles["page-container"]}>
      <LayoutHeader
        headerTitle="Settings"
        amount={dashboardData?.amount || 0}
        currency={dashboardData?.currency || "AED"}
      />

      <div className={styles["wrapper"]}>
        <div className={styles["wrapper__head"]}>
          <div className={styles["button-wrapper"]}>
            <div
              className={getTabClass(SETTINGS_TABS.PROFILE)}
              onClick={() => setActiveTab(SETTINGS_TABS.PROFILE)}
            >
              Profile
            </div>
            <div
              className={getTabClass(SETTINGS_TABS.CHANGE_PASSWORD)}
              onClick={() => setActiveTab(SETTINGS_TABS.CHANGE_PASSWORD)}
            >
              Change Password
            </div>
          </div>
        </div>
        <div className={styles["wrapper__body"]}>
          {activeTab === SETTINGS_TABS.PROFILE && <SettingsProfile />}
          {activeTab === SETTINGS_TABS.CHANGE_PASSWORD && <ChangePassword />}
        </div>
      </div>
    </div>
  );
};

export default Settings;
